import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import Icon from "../../../components/Icon";
import Modal from "../../../components/Modal";
import Configuration, { translations } from "../../../config";
import Form from "../../../components/Form";
import { deleteDocument, downloadDocument, getQuestionnaireDocuments, uploadQuestionnaireDocument } from "../actions/Documents";
import { message } from "../../../actions";

const mapStateToProps = ( state ) =>
{
	return {
		documentsByQuestionnaireId: state.documentsByQuestionnaireId
	};
};

const mapDispatchToProps = ( dispatch ) =>
{
	return {
		getQuestionnaireDocuments: ( id ) =>
		{
			dispatch( getQuestionnaireDocuments( id ) );
		},
		uploadQuestionnaireDocument: ( a_form, questionnaire_id ) =>
		{
			dispatch( uploadQuestionnaireDocument( a_form, questionnaire_id ) );
		},
		downloadDocument: ( a_id, a_filename ) =>
		{
			dispatch( downloadDocument( a_id, a_filename ) );
		},
		deleteDocument: ( id, questionnaire_id ) =>
		{
			dispatch( deleteDocument( id, questionnaire_id ) );
		},
		message: ( a_message, a_type, a_timeout ) =>
		{
			dispatch( message( a_message, a_type, a_timeout ) );
		}
	};
};

/**
 * Dokumentenkomponente der GUI
 */
class Documents extends React.Component
{
	constructor( props )
	{
		super( props );
		
		this.state = {
			isExpand: false
		};
		
		this.handleDelete = this.handleDelete.bind( this );
		this.handleUpload = this.handleUpload.bind( this );
		this.handleExport = this.handleExport.bind( this );
		this.handleExpand = this.handleExpand.bind( this );
		
	} // function constructor(...)
	
	componentDidMount()
	{
		this.props.getQuestionnaireDocuments( this.props.questionnaireId );
		
	} // function componentDidMount()
	
	handleDelete( a_event, id, questionnaire_id )
	{
		a_event.preventDefault();
		
		this.props.deleteDocument( id, questionnaire_id );
		
	} // function handleDelete(...)
	
	handleUpload( a_event, a_formData, a_questionnaire_id )
	{
		a_event.preventDefault();
		
		this.props.uploadQuestionnaireDocument( a_formData, a_questionnaire_id );
		
	} // function handleUpload(...)
	
	handleExport( a_event, a_document )
	{
		a_event.preventDefault();
		
		this.props.downloadDocument( a_document.id, a_document.name );
		
	} // function handleExport(...)
	
	formatBytes( a_size, a_scale )
	{
		if ( 0 === a_size )
		{
			return "0 Bytes";
		}
		let c = 1024,
			d = a_scale !== undefined ? a_scale : 2,
			e = [ "Bytes", "KB", "MB" ],
			f = Math.floor( Math.log( a_size ) / Math.log( c ) );
		
		return parseFloat( ( a_size / Math.pow( c, f ) ).toFixed( d ) ) + " " + e[f];
		
	} // function formatBytes(...)
	
	handleExpand()
	{
		this.setState( { isExpand: !this.state.isExpand } );
		
	} // function handleExpand(...)
	
	render()
	{
		const { documentsByQuestionnaireId, questionnaireId } = { ...this.props };
		
		return (
			/* Dokumentupload ausblenden wenn nicht benötigt. */
			!this.state.isExpand
				? <section className={"white unset-padding hiddenDocuments"}>
					<div className={"col s12"}>
						<h4 className={"col s8 margin-top"}>Dokumente</h4>
						<div className={"actions actions-right"}>
							<button className="btn btn-small btn-flat transparent right"
							        onClick={() => this.handleExpand()}>
								<Icon iconName={this.state.isExpand ? "shrink" : "expand"}/>
							</button>
						</div>
					</div>
				</section>
				: <section className={"white unset-padding contentDocuments"}>
					<div className={"actions actions-right"}>
						<button className="btn btn-small btn-flat transparent right"
						        onClick={() => this.handleExpand()}>
							<Icon iconName={this.state.isExpand ? "shrink" : "expand"}/>
						</button>
					</div>
					<div className={"col s12 l6 xl4 light-grey left-border-radius"}>
						<div className={"table"}>
							<div className={"col s12"}>
								<h4>Dokument</h4>
							</div>
							<Form
								id={`form-new-document`}
								
								onSubmit={( event, formData ) => this.handleUpload( event, formData, questionnaireId )}
								className="col s12"
								fields={[
									{
										name: "title",
										title: "Titel",
										type: "text",
										required: true,
										className: "col s12",
										maxLength: "40"
									},
									{
										name: "file_upload",
										title: "Dokument",
										type: "file",
										className: "col s12",
										required: true,
										cleared: true
									}
								]}
								errorMessage={( a_message, a_type, a_timeout ) => this.props.message( a_message, a_type, a_timeout )}
								submitValue={[ <Icon key={`form-new-file-icon`} iconName={"saveFile"}/>, <span key={`form-new-file-text`}>Dokument hochladen</span> ]}
							/>
						</div>
					</div>
					<div className={"col s12 l6 xl8"}>
						<div className={"table"}>
							<div className={"col s12"}>
								<h4>Dokumente</h4>
							</div>
							{
								documentsByQuestionnaireId.hasOwnProperty( questionnaireId ) &&
								Object.keys( documentsByQuestionnaireId[questionnaireId] ).length > 0 ?
									<div className={"col s12"}>
										
										<ul className={"collection"}>
											<li className={"collection-item"} key={"users_header"}>
												<div className="col s12">
													<div className={"col s12 xl7"}><label>Titel</label><br/><label>Dateiname</label></div>
													<div className={"col s12 xl2"}><label>Upload Datum</label><br/><label>Größe</label></div>
												</div>
											</li>
											{
												documentsByQuestionnaireId.hasOwnProperty( questionnaireId ) &&
												Object.keys( documentsByQuestionnaireId[questionnaireId] ).length > 0 &&
												Object.keys( documentsByQuestionnaireId[questionnaireId] )
													.map(
														( a_key ) =>
														{
															// Umrechnung der Dateigröße für die Anzeige
															const document = documentsByQuestionnaireId[questionnaireId][a_key];
															const fileSize = this.formatBytes( document.file_size, 0 );
															
															return [
																document &&
																<li className={"collection-item"} key={`document_id_${document.id}`}>
																	<div className="col s12">
																		<div className={"col s12 xl7"}>{document.title}<br/>{document.name}</div>
																		<div className={"col s12 xl2"}>
																			{new Date( document.created_at ).toLocaleDateString( Configuration.location )}<br/>
																			{fileSize}
																		</div>
																		<div className={"col s12 xl3 icon-bar tRight"}>
																			<button className="btn btn-large btn-flat hover-light-grey icon-shadow"
																			        key={`questionnaire_export_id_${questionnaireId}`}
																			        onClick={( event ) => this.handleExport( event, document )}
																			        download={true}>
																				<Icon iconName={document.mime_type} size={25}/>
																			</button>
																			<Modal className={"confirm"}
																			       key={"document_delete_modal"}
																			       trigger={
																				       <button className={"btn btn-large btn-flat red-text hover-red hover-white-text icon-shadow"}
																				               key={`delete_document_id_${document.id}`}>
																					       <Icon iconName={"delete"} size={25}/>
																				       </button>
																			       }
																			       footer={
																				       <React.Fragment>
																					       <button onClick={( event ) => this.handleDelete( event, document.id, questionnaireId )}
																					               data-modal={"confirm"}>
																						       <Icon size={14} iconName={"delete"}/><span>Ja</span>
																					       </button>
																					       <button className={"secondary-color"} data-modal={"close"}><Icon
																						       iconName={"discard"}/><span>Nein</span>
																					       </button>
																				       </React.Fragment>
																			       }
																			>
																				<p className={"tCenter"}>Soll das Dokument gelöscht werden?</p>
																			</Modal>
																		</div>
																	</div>
																</li>
															];
														}
													)
											}
										</ul>
									</div>
									:
									<div className={"col s12"}><p>Für diesen {translations.de_DE.words.questionnaire} wurden noch keine Dokumente hochgeladen.</p></div>
							}
						</div>
					</div>
				</section>
		);
		
	} // function render()
	
} // class

Documents.propTypes = {
	questionnaireId: PropTypes.oneOfType( [ PropTypes.number, PropTypes.string ] ).isRequired
};

Documents = connect(
	mapStateToProps,
	mapDispatchToProps
)( Documents );

export default Documents;